import React, { useState } from 'react';
import './Header.scss';
import { ReactComponent as CreativeIcon } from '../../assets/img/creativeIcon.svg';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);

  const handleScroll = () => {
    if (window.scrollY >= 500) {
      setIsScrolled(true);
    } else {
      setIsScrolled(false);
    }
  };

  window?.addEventListener('scroll', handleScroll);

  return (
    <header
      className={`${isScrolled ? 'scrolled' : ''}`}
      onScroll={() => console.log('helooo')}
    >
      <a id='logo' href='#' aria-label='home'>
        <div id='svgContainer' data-bm-renderer='svg'>
          <CreativeIcon />
        </div>
      </a>
    </header>
  );
}
